const initialState = {
  bookmarks: [],
  bookmarkIds: [],
  bookmarkPosts: [],
  bookmarkCount: 0,
  bookmarkCurrent: 1,
};

const book = (state = initialState, action) => {
  switch (action.type) {
    case "GET_BOOKMARKS":
      //worksaround to fix null values in bookmark posts causing null exception in frontend
      let nonNullBookmarksPosts = action.bookmarks
        .map((boo) => boo?.post)
        .map((pos) => {
          if (pos && pos["sections"]) {
            pos.sections = pos.sections.sort((a, b) => a.position - b.position);
          }
          return pos;
        });
      let bPosts = [];
      for (let i = 0; i < nonNullBookmarksPosts.length; i++) {
        if (nonNullBookmarksPosts[i]) {
          bPosts.push(nonNullBookmarksPosts[i]);
        }
      }
      //above code written because some data was deleted from the database and null vlaues were being returned
      return {
        ...state,
        bookmarks: action.bookmarks,
        bookmarkIds: action.bookmarks.map((boo) => boo?.post?.id),
        bookmarkPosts: bPosts,
        bookmarkCount: action.bookmarkCount,
        bookmarkCurrent: action.bookmarkCurrent,
      };

    case "RESET_BOOK_STATE":
      return {
        ...initialState,
      };

    default:
      return { ...state };
  }
};

export default book;
